import { Navigate } from 'react-router-dom';
import { matchdayApi } from '@/api/endpoints';
import type { Matchday } from '@/api/types';
import { Alert, Card, Spinner } from '@/components/ui';
import { pickCurrentMatchday } from '@/lib/matchday';
import { useAsync } from '@/lib/useAsync';

/** Menüpunkt "Tippübersicht": springt direkt in die Tabelle des aktuellen Spieltags. */
export function TippuebersichtIndexPage() {
  const { data, loading, error } = useAsync<Matchday[]>((signal) => matchdayApi.list(signal), []);

  if (loading) return <Spinner label="Spieltage werden geladen…" />;
  if (error) return <Alert>{error}</Alert>;

  const target = pickCurrentMatchday(data ?? []);

  if (!target) {
    return (
      <Card>
        <p className="muted">Aktuell sind keine Spieltage veröffentlicht.</p>
      </Card>
    );
  }

  return <Navigate to={`/matchdays/${target.id}/overview`} replace />;
}
